/**
 * Wells per well-list page. Jump to Location's Well Name labels request the same
 * page from data-svc-rs `/api/v1/uwi/{filterId}/well-names`, which rejects a
 * `limit` above `MAX_WELL_NAMES_PAGE` (50,000, in `controllers/uwi.rs`) with a
 * 400. Raising this past that ceiling needs that constant raised too, or every
 * Well Name lookup fails.
 */
export const WELL_LIST_PAGE_SIZE = 50000;

/**
 * Largest filter Edit Well List pages through in full (4 pages). Above it, the
 * editor opens with only the loaded page.
 */
export const WELL_LIST_FETCH_ALL_LIMIT = WELL_LIST_PAGE_SIZE * 4;
